
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  OrderSuggestion,
  OrderSuggestionCorrectionSuggestion,
} from '@/types/ApiInterfaces';

@Component
export default class NewOrderTooltip extends Vue {
  @Prop(String)
  productNr!: string;

  active = true;

  get action(): string {
    return this.$store.getters['order/suggestionAction'];
  }

  get suggestion(): OrderSuggestion {
    return this.$store.state.order.suggestion;
  }

  get product(): OrderSuggestionCorrectionSuggestion | undefined {
    if (this.suggestion.CorrectionSuggestion) {
      return this.suggestion.CorrectionSuggestion;
    }
    return undefined;
  }

  get quantity(): number {
    const quantity = this.suggestion.CorrectionSuggestion
      ? this.product?.NumPallets || 0
      : 0;
    return Math.abs(quantity);
  }

  close() {
    // Cancel the suggestion
    if (this.action !== 'suggest-remove') {
      this.$store.commit('order/setSuggestionCancelled', true);
    }
    this.active = false;
  }

  toggle() {
    this.active = !this.active;
  }

  accept() {
    this.$emit('accept', this.product);
    this.close();
  }

  // Simplified version of Markdown formatting
  format(md: string): string {
    return md.replace(/\*\*(.*)\*\*/g, '<strong>$1</strong>');
  }

  mounted() {
    const ref: any = this.$refs.scrollAnchor;
    if (ref) {
      ref.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
